import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotificationService, ServerRootService } from '@se/se.ui.html5';
import { firstValueFrom } from 'rxjs';

export interface ISourceItemData {
    guid: string;
    description: string;
}

export type ControllerNames = 'ListEcg' | 'List' | 'ListCpReporting' | 'ListWorkFlow';

export enum LsNames {
    lsBusinessUnit = 'lsBusinessUnit',
    lsNurse = 'lsNurse',
    lsSonographer = 'lsSonographer',
    lsUsMeasureExtension = 'lsUsMeasureExtension',
    lsUsEquipment = 'lsUsEquipment',
    lsModality = 'lsModality',
    lsEquipment = 'lsEquipment',
    lsPostgraduate = 'lsPostgraduate',
    lsExam = 'lsExam',
    lsReferringPhysician = 'lsReferringPhysician',
    lsProvenance = 'lsProvenance',
    lsProvenanceGroup = 'lsProvenanceGroup',
    lsRoom = 'lsRoom',
    lsSeverity = 'lsSeverity',
    lsRequestingPhysician = 'lsRequestingPhysician',
    lsRole = 'lsRole',
    lsVisitType = 'lsVisitType',
    lsAdministrator = 'lsAdministrator',
    lsTechnician = 'lsTechnician',
    lsAnaesthetist = 'lsAnaesthetist',
    LsUser = 'LsUser',
    lsExecutor = 'lsExecutor',
    LsAgenda = 'LsAgenda',
    lsSuspensionReason = 'lsSuspensionReason',
    lsDeletingReason = 'lsDeletingReason',
}

export interface ICacheResultDict {
    ListEcg: Record<string, ISourceItemData[]>;
    List: Record<string, ISourceItemData[]>; //oggi si chiama listcontroller va rifattorizzato a list visit in sync con il backend
    ListCpReporting: Record<string, ISourceItemData[]>;
    ListWorkFlow: Record<string, ISourceItemData[]>;
}

@Injectable({
    providedIn: 'root',
})
export class ListDataSourceService extends ServerRootService {
    listCache: ICacheResultDict = {
        ListEcg: {},
        List: {},
        ListCpReporting: {},
        ListWorkFlow: {},
    };

    constructor(
        private httpClient: HttpClient,
        private notificationService: NotificationService,
    ) {
        super();
    }

    async getList(controllerName: ControllerNames, listName: LsNames, forceResetCache = false) {
        if (!forceResetCache && this.listCache[controllerName][listName]?.length) {
            return this.listCache[controllerName][listName];
        }
        try {
            return await firstValueFrom(
                this.httpClient.get<ISourceItemData[]>(
                    `${this.getServerRoot()}/${controllerName}/GetListItems?lsName=${listName}`,
                    this.buildOptions(),
                ),
            );
        } catch (err: any) {
            console.error(err);
            this.notificationService.error(err.message, `${controllerName}/${listName}`);
            this.listCache[controllerName][listName] = [];
            return [];
        }
    }

    async getLsUsMeasureExtension(forceResetCache = false) {
        return this.getList('List', LsNames.lsUsMeasureExtension, forceResetCache);
    }

    async getLsUsEquipment(forceResetCache = false) {
        return this.getList('List', LsNames.lsUsEquipment, forceResetCache);
    }

    async getLsSeverity(forceResetCache = false) {
        return this.getList('ListWorkFlow', LsNames.lsSeverity, forceResetCache);
    }

    async getLsRole(forceResetCache = false) {
        return this.getList('ListWorkFlow', LsNames.lsRole, forceResetCache);
    }

    async getLsSuspensionReason(forceResetCache = false) {
        return this.getList('ListWorkFlow', LsNames.lsSuspensionReason, forceResetCache);
    }

    async getLsDeletingReason(forceResetCache = false) {
        return this.getList('ListWorkFlow', LsNames.lsDeletingReason, forceResetCache);
    }
}
